import {ReportRow} from '../../ReportTypes';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';

export const shareReport = (report: ReportRow): void => {
	showModal({
		type: MODAL_TYPE.SHARE_REPORT_MODAL,
		reportId: report.id,
		reportSharesInput: report.shares?.edges?.map(share => {
			return {
				email: share?.node?.user?.email,
				sharedId: share?.node?.id,
				userId: share?.node?.user?.id,
				permissionType: share?.node?.permissionType ?? 'VIEWER',
				isInternal: share?.node?.user?.isInternal ?? false,
			};
		}),
		privateAccessInput: report.privateAccess,
		reportOwner: report.person,
		reportType: report.type,
	});
};
